// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__o0CdF","paramInput":"JobSimulator_paramInput__205m0","input":"JobSimulator_input__t5bVi"};